import React from "react";

import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "@remix-run/react";
import * as Sentry from "@sentry/react";

import { getSentryDsn, isSentryEnabled } from "~/lib/env.shared";

export const setupSentry = () => {
    if (!isSentryEnabled()) return;

    Sentry.init({
        dsn: getSentryDsn(),
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/app\.ifscompanion\.com\/api/,
            /^https:\/\/app\.ifscompanion\.org\/api/,
            /^https:\/\/app\.ifsobserver\.com\/api/,
        ],
        tracesSampler: (samplingContext) => {
            if (samplingContext.name.includes("http-intake")) {
                return 0;
            }
            if (samplingContext.name.includes("http-intake")) {
                return 0;
            }
            return 1;
        },
    });
};

export const setSentryUser = (userId: string | null, email: string | null) => {
    if (!isSentryEnabled()) return;

    Sentry.setUser({
        id: userId || undefined,
        email: email || undefined,
    });
};
